"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const atoms_1 = require("@components/atoms");
const AccountInHeader_1 = require("@components/organisms/AccountInHeader");
const _store_1 = __importDefault(require("@store")); // Component
var AccountCheckEmail = function AccountCheckEmail() {
    var _useGlobal = _store_1.default(function (state) {
        return state.panel;
    }, function (actions) {
        return actions.setPanel;
    }), setPanel = _useGlobal[1];
    var _useGlobal2 = _store_1.default(function (state) {
        return state.regBundle;
    }, function (actions) {
        return actions.setRegBundle;
    }), regBundle = _useGlobal2[0];
    return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.BackButton, {
        onClick: function onClick() {
            return setPanel('login');
        }
    }, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Arrow, null)), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, {
        orderReverse: true,
        alignCenter: true
    }, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Header, {
        noPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.EyebrowLabel, {
        alignment: "left",
        isDrawer: true
    }, "Verify your Account"), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Headline, null, "We sent a unique link to: ", regBundle === null || regBundle === void 0 ? void 0 : regBundle.email), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Caption, null, "Please check your email for instructions. If your email hasn't arrived within five minutes check your spam folder or click the link below."), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.TriggerWrapper, {
        paddingTop: true
    }, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Trigger, {
        alignLeft: true,
        onClick: function onClick() {
            return setPanel('login');
        }
    }, "Resend Link")))), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.StyledImage, {
        src: "/images/accounts/checkEmail.png",
        objectFit: "contain"
    })));
};
exports.default = AccountCheckEmail;
